import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import api from '../services/api';

export default function LocatieInfoImport() {
  const [rows, setRows] = useState([]);
  const [bestand, setBestand] = useState('');
  const [bezig, setBezig] = useState(false);
  const [res, setRes] = useState(null);
  const [fout, setFout] = useState('');

  const exporteer = async () => {
    setBezig(true); setFout('');
    try {
      const r = await api.get('/locatie-velden/export');
      const kol = ['ID', 'Locatie', 'Adres', 'Actief', ...(r.data.kolommen || [])];
      const ws = XLSX.utils.json_to_sheet(r.data.rijen || [], { header: kol });
      ws['!cols'] = kol.map((k, i) => ({ wch: i === 0 ? 7 : i === 2 ? 35 : i === 3 ? 8 : Math.max(14, k.length + 2) }));
      ws['!freeze'] = { xSplit: 2, ySplit: 1 };
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Locatie info');
      XLSX.writeFile(wb, 'locatie_info_' + new Date().toISOString().slice(0, 10) + '.xlsx');
    } catch (e) { setFout('Export mislukt: ' + (e.response?.data?.message || e.message)); }
    setBezig(false);
  };

  const lees = (e) => {
    const f = e.target.files && e.target.files[0]; if (!f) return;
    setRes(null); setFout(''); setBestand(f.name);
    const rd = new FileReader();
    rd.onload = (ev) => {
      try {
        const wb = XLSX.read(new Uint8Array(ev.target.result), { type: 'array' });
        const data = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { defval: '', raw: false });
        setRows(data.filter(r => String(r.Locatie || r.locatie || r.ID || r.id || '').trim()));
      } catch (err) { setFout('Kan bestand niet lezen: ' + err.message); }
    };
    rd.readAsArrayBuffer(f);
  };

  const importeer = async () => {
    setBezig(true); setFout('');
    try { const r = await api.post('/locatie-velden/import', rows); setRes(r.data); setRows([]); setBestand(''); }
    catch (e) { setFout('Import mislukt: ' + (e.response?.data?.message || e.message)); }
    setBezig(false);
  };

  const kolommen = rows.length ? Object.keys(rows[0]).filter(k => !['id', 'locatie', 'adres', 'actief'].includes(k.toLowerCase())) : [];
  const knop = { padding: '10px 16px', borderRadius: 8, border: 'none', fontWeight: 600, cursor: 'pointer' };

  return (
    <div>
      <p>Werkwijze: <strong>exporteer</strong> de huidige locatie-info, vul aan of pas aan in Excel, en <strong>importeer</strong> het bestand terug.
        Locaties worden gevonden op <strong>ID</strong> (of anders op naam). Een lege cel laat de bestaande waarde staan; een nieuwe kolom wordt een nieuw veld.</p>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center', margin: '12px 0' }}>
        <button disabled={bezig} onClick={exporteer} style={{ ...knop, background: '#0f766e', color: '#fff' }}>📤 Exporteer locatie-info</button>
        <label style={{ ...knop, background: '#e5e7eb', color: '#111' }}>📁 Kies Excel
          <input type="file" accept=".xlsx,.xls,.csv" onChange={lees} style={{ display: 'none' }} />
        </label>
        {bestand && <span style={{ fontSize: 13, color: '#555' }}>{bestand}: {rows.length} locaties</span>}
      </div>
      {rows.length > 0 && (
        <div style={{ margin: '8px 0 12px', padding: 12, background: '#f0f9ff', borderRadius: 8, fontSize: 13 }}>
          <div><strong>Velden in bestand:</strong> {kolommen.join(', ') || '(geen)'}</div>
          <div style={{ marginTop: 4 }}><strong>Eerste locaties:</strong> {rows.slice(0, 5).map(r => r.Locatie || r.locatie || ('ID ' + (r.ID || r.id))).join(', ')}{rows.length > 5 ? ' …' : ''}</div>
          <button disabled={bezig} onClick={importeer} style={{ ...knop, marginTop: 10, background: '#2563eb', color: '#fff' }}>{bezig ? 'Bezig…' : '⬆️ Importeer ' + rows.length + ' locaties'}</button>
        </div>
      )}
      {res && (
        <div style={{ padding: 12, background: '#ecfdf5', borderRadius: 8, fontSize: 14 }}>
          ✅ {res.bijgewerkt} waarden bijgewerkt, {res.toegevoegd} toegevoegd{res.gedeactiveerd ? ', ' + res.gedeactiveerd + ' locaties inactief gezet' : ''}{res.geactiveerd ? ', ' + res.geactiveerd + ' weer actief' : ''}.
          {res.onbekend && res.onbekend.length > 0 && <div style={{ marginTop: 6, color: '#b45309' }}>⚠️ Niet gevonden ({res.onbekend.length}): {res.onbekend.slice(0, 20).join(', ')}{res.onbekend.length > 20 ? ' …' : ''}</div>}
        </div>
      )}
      {fout && <div style={{ padding: 10, background: '#fef2f2', color: '#b91c1c', borderRadius: 8, marginTop: 8 }}>{fout}</div>}
      <style>{'.upload-section{display:none}'}</style>
    </div>
  );
}
